<template>
	<b-modal
		v-model="showModal"
		id="ticketHistory"
		:centered="isLaptop"
		:modal-class="!isLaptop ? 'bottom-modal' : ''"
		hide-footer
		hide-header
		no-close-on-backdrop
	>
		<section class="d-flex w-100 justify-content-between gap-3 px-4 py-3">
			<h2 class="fw-500 fs-18 font-lato color-darkblack">Ticket History</h2>
			<img
				class="pointer rotate-on-hover"
				@click="close()"
				src="@/assets/newdesign/jdprogress/x-close.svg"
				alt=""
			/>
		</section>
		<hr class="m-0" style="border-top: 1px solid #e4e7ec" />
		<div class="thm-overflow">
			<article
				v-for="(ticket, index) in ticketData.activity"
				:key="index"
				class="mb-3"
			>
				<div
					class="d-flex align-items-center justify-content-between"
					:class="activeIndex === index ? 'collapse-head' : 'collapse-nohead'"
					@click="toggleCollapse(index)"
				>
					<div>Remark {{ index + 1 }}</div>
					<div>
						<img
							:class="{ rotated: activeIndex === index }"
							class="pointer"
							src="@/assets/paneldashboard/downarrow.svg"
							alt=""
						/>
					</div>
				</div>

				<b-collapse :visible="activeIndex === index">
					<div class="p-3">
						<div class="font-mont fs-13 fw-400 color-696969">Reason:</div>
						<div class="font-lato fw-400 fs-15 color-black mt-1">
							{{ ticket.title }}
						</div>
						<div class="font-mont fs-13 fw-400 color-696969 mt-3">Remarks:</div>
						<div class="font-lato fw-400 fs-15 color-black mt-1">
							{{ ticket.remarks }}
						</div>
						<hr />
						<div class="d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center gap-2">
								<img src="@/assets/paneldashboard/remarks-dp.svg" alt="" />
								<span class="font-lato fw-600 fs-14 color-black">
									{{ ticket.activityByName ? ticket.activityByName : "N/A" }}
								</span>
							</div>
							<div class="font-mont fs-13 fw-400 color-696969">
								{{ formatDate(ticket.activityAt) }}
							</div>
						</div>
					</div>
				</b-collapse>
			</article>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "TicketHistoryModal",
	data() {
		return {
			activeIndex: null,
			isLaptop: true,
		};
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	watch: {
		showModal(newVal) {
			if (newVal && this.ticketData?.activity?.length) {
				this.activeIndex = this.ticketData.activity.length - 1;
			}
		},
	},
	props: {
		showModal: Boolean,
		ticketData: Object,
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1028;
		},
		toggleCollapse(index) {
			this.activeIndex = this.activeIndex === index ? null : index;
		},
		close() {
			this.$emit("close");
		},
		formatDate(date) {
			return date.replace(/-/g, "/");
		},
	},
};
</script>

<style>
#ticketHistory .modal-body {
	padding: 0;
}
#ticketHistory .modal-dialog {
	max-width: 600px;
}
.thm-overflow {
	height: calc(100vh - 500px);
	max-height: 600px;
	min-height: 500px;
	overflow: auto;
	padding: 15px;
}
.thm-overflow article {
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	border-radius: 8px;
	overflow: hidden;
}
.thm-overflow .collapse-head {
	background-color: #eef3f7;
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #000000;
	padding: 12px 15px;
}
.thm-overflow .collapse-nohead {
	background-color: #ffffff;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 16px;
	color: #20639b;
	padding: 12px 15px;
}
.rotated {
	transform: rotate(180deg);
	transition: transform 0.3s ease;
}
</style>
